import React, { useCallback, useEffect } from 'react';
import { useScrollLock } from '../../_utils/useScrollLock';
import ReactDOM from 'react-dom';
import CloseButton from './CloseButton';
import './HelpWalkthrough.css';

// A single-panel version of the HelpWalkthrough shell: centred pop-up on web,
// slide-up sheet on mobile. Deliberately reuses HelpWalkthrough's classes
// rather than restyling, so anything opened from an `i` matches what opens
// from the `?` on the same page.
//
// Props:
//   eyebrow  — small uppercase kicker, e.g. "Your balance"
//   children — panel content
//   onClose  — called when dismissed
export const InfoSheet = ({ eyebrow, children, onClose }) => {
  const [closing, setClosing] = React.useState(false);

  const handleClose = useCallback(() => {
    if (closing) return;
    setClosing(true);
    setTimeout(() => { if (onClose) onClose(); }, 240);
  }, [closing, onClose]);

  // Shared ref-counted scroll lock: overlapping overlays must not restore
  // each other's locked styles.
  useScrollLock(true);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') handleClose(); };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
    };
  }, [handleClose]);

  const cc = closing ? ' closing' : '';

  return ReactDOM.createPortal(
    <div className={'hw-overlay' + cc} onClick={handleClose}>
      <div
        className={'hw-modal' + cc}
        role="dialog"
        aria-modal="true"
        aria-label={eyebrow}
        onClick={(e) => e.stopPropagation()}
      >
        <CloseButton className="hw-close" onClick={handleClose} />
        {eyebrow && <div className="hw-eyebrow">{eyebrow}</div>}
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default InfoSheet;
